import {
  ref,
  reactive,
  getCurrentInstance,
  computed,
  onBeforeMount,
  watch,
} from "@vue/composition-api";

export default function useSurveytem(props) {
  const vm = getCurrentInstance().proxy;

  const customQuillOption = {
    theme: "snow",
    modules: {
      toolbar: {
        container: "#my-toolbar",
      },
      // "emoji-toolbar": true,
      // "emoji-textarea": true,
      // "emoji-shortname": true,
      keyboard: {
        bindings: {
          "list autofill": {
            prefix: /•\\s\\d\\.\\s[A-z]/,
          },
        },
      },
    },
  };

  const FORMQUESTION = {
    TYPE: {
      SINGLE: 1,
      MULTIPLE: 2,
      TEXTAREA: 3,
      DATE: 4,
      DROPDOWN: 5,
    },
    FORMAT: {
      TEXT: 1,
      IMAGE: 2,
      TEXTIMAGE: 3,
    },
    NEXTSTEP: {
      OTHERQUESTION: 3,
      OTHERSECTION: 4,
      SETTINGBYCHOICE: 5,
    },
  };

  const activeHover = {
    SURVEY_NAME: 1,
    SURVEY_DESC: 2,
  };

  const activeQuestion = ref(false);
  const activeDesc = ref(false);

  const toggledInputFocus = (type) => {
    switch (type) {
      case activeHover.SURVEY_NAME:
        activeQuestion.value = true;
        activeDesc.value = false;

        props.activeEditor.questionName = true;
        props.activeEditor.Desc = false;
        break;
      case activeHover.SURVEY_DESC:
        activeQuestion.value = false;
        activeDesc.value = true;

        props.activeEditor.questionName = false;
        props.activeEditor.Desc = true;
        break;
      default:
        activeQuestion.value = false;
        activeDesc.value = false;

        props.activeEditor.questionName = false;
        props.activeEditor.Desc = false;
    }
  };

  const toggleActive = () => {
    vm.$emit("set-active", props.formQuestion.questionId);
  };

  const questionActionList = reactive({
    continue: {
      label: "Continue to Next Question",
      value: 2,
      display: true,
    },
    otherQuestion: {
      label: "Go to other Questions",
      value: 3,
      display: true,
    },
    otherSection: {
      label: "Go to other Section",
      value: 4,
      display: true,
    },
    settingChoice: {
      label: "Setting by Choice",
      value: 5,
      display: true,
    },
    submit: {
      label: "Submit From",
      value: 6,
      display: true,
    },
  });

  const questionActionListNoSetChoice = reactive({
    continue: {
      label: "Continue to Next Question",
      value: 2,
      display: true,
    },
    otherQuestion: {
      label: "Go to other Questions",
      value: 3,
      display: true,
    },
    otherSection: {
      label: "Go to other Section",
      value: 4,
      display: true,
    },
    submit: {
      label: "Submit From",
      value: 6,
      display: true,
    },
  });

  const createSettingByChoice = () => {
    if (!props.isEdit) {
      vm.$emit("EditQuestion");
    }
  };

  const resolveQuestionList = (question) => {
    if (question.type == 2 || question.type == 3 || question.type == 4) {
      return questionActionListNoSetChoice;
    } else {
      return questionActionList;
    }
  };

  const resolveQuestionAction = (type) => {
    props.formQuestion.linkToType = type;
    switch (type) {
      case questionActionList.continue.value:
        return;
      case questionActionList.otherQuestion.value:
        return;
      case questionActionList.otherSection.value:
        return;
      case questionActionList.settingChoice.value:
        return createSettingByChoice();
      case questionActionList.submit.value:
        return;
      default:
    }
  };

  const onAddChoice = () => {
    vm.$emit("onAddChoice", props.formQuestion);
  };

  const onAddOther = () => {
    vm.$emit("onAddOther", props.formQuestion);
  };

  const onRemoveChoice = (element) => {
    const index = props.formQuestion.dataChoice.indexOf(element);
    vm.$emit(
      "onRemoveChoice",
      index,
      props.formQuestion.dataChoice,
      props.formQuestion
    );
  };

  const onUploadImage = (image, element) => {
    vm.$emit("onUploadImage", image, props.formQuestion);
  };

  const onUploadImageChoice = (image, element) => {
    const idx = props.formQuestion.dataChoice.indexOf(element);
    vm.$emit("onUploadImageChoice", image, props.formQuestion.dataChoice[idx]);
  };

  const onChangeFormat = () => {
    props.formQuestion.isOther = false;
    props.formQuestion.linkToType = 2;
    props.formQuestion.dataChoice = [
      {
        seqChoice: "",
        choiceId: "",
        questionId: "",
        choiceName: "",
        imageChoice: { file: null, url: null },
        other: false,
        nextstep_type: "",
        nextstep_option: formQuestionArr.obj,
        nextSectionId: "",
        nextQuestionId: "",
      },
    ];
  };

  const onDuplicateQuestion = (questionObj) => {
    vm.$emit("onDuplicateQuestion", questionObj);
  };

  const nameNoHtml = computed(() =>
    props.formQuestion.questionName.replace(/<[^>]*>/g, "")
  );

  const descNoHtml = computed(() =>
    props.formQuestion.questionDesc
      ? props.formQuestion.questionDesc.replace(/<[^>]*>/g, "")
      : ""
  );

  let tagOption = reactive({
    optionQuestion: [],
    optionChoice: [],
    optionSection: [],
    changeOptionSection: [],
    changeOptionQuestion: [],
    changeOptionChoice: [],
  });

  const formQuestionArr = reactive({
    payload: [],
    obj: [],
  });

  const onSetOption = () => {
    formQuestionArr.payload = [...props.formQuestion.nextstepOptionOfOption];
    //option section
    let filterOptionSection = props.formQuestion.nextstepOption.filter(
      (o) => o.nextstep_type == 4
    );

    tagOption.optionSection = filterOptionSection.map((obj) => ({
      value: obj.next_sectionid,
      label: obj.nextstep_desc,
    }));

    tagOption.changeOptionSection = filterOptionSection.filter(
      (o) => o.next_sectionid == props.formQuestion.nextSectionId
    );

    if (tagOption.changeOptionSection.length == 0) {
      props.formQuestion.nextSectionId = "";
    }

    //option question

    let filterOptionQuestion = props.formQuestion.nextstepOption.filter(
      (o) => o.nextstep_type == 3
    );

    tagOption.optionQuestion = filterOptionQuestion.map((obj) => ({
      value: obj.next_questionid,
      label: obj.nextstep_desc,
    }));

    tagOption.changeOptionQuestion = filterOptionQuestion.filter(
      (o) => o.next_questionid == props.formQuestion.nextQuestionId
    );

    if (tagOption.changeOptionQuestion.length == 0) {
      props.formQuestion.nextQuestionId = "";
    }

    //option choice

    tagOption.optionChoice = formQuestionArr.payload.map((obj, index) => ({
      value: index,
      obj: { ...obj },
      label: obj.nextstep_desc,
    }));

    props.formQuestion.dataChoice.map((o) => {
      if (o.other == true) {
        props.formQuestion.isOther = true;
      }
    });

    let choiceData = {};
    formQuestionArr.payload.map((o) => {
      choiceData = o;
    });

    tagOption.changeOptionQuestion = formQuestionArr.payload.filter(
      (o) => o.next_questionid == choiceData.nextstep_type
    );
  };

  watch(
    () => props.formQuestion,
    () => {
      onSetOption();
    },
    { deep: true }
  );

  watch(
    () => props.activeEditor,
    () => {
      activeQuestion.value = props.activeEditor.questionName;
      activeDesc.value = props.activeEditor.Desc;
    },
    { deep: true }
  );

  onBeforeMount(() => {
    onSetOption();
  });

  return {
    customQuillOption,
    toggledInputFocus,
    activeQuestion,
    activeDesc,
    activeHover,
    toggleActive,
    resolveQuestionAction,
    questionActionList,
    onAddChoice,
    onAddOther,
    onRemoveChoice,
    onUploadImage,
    onUploadImageChoice,
    onChangeFormat,
    onDuplicateQuestion,
    nameNoHtml,
    descNoHtml,
    tagOption,
    resolveQuestionList,
    FORMQUESTION,
  };
}
